import { sendLoginEvent } from './gtag-helper-functions.js'

class HHLoginForm extends HTMLElement {
  connectedCallback() {
    this.$submit = this.querySelector('.js-login-submit')
    this.$loginForm = this.querySelector('#customer_login')
    this.email = this.querySelector('#CustomerEmail')
    this.passwd = this.querySelector('#CustomerPassword')
    this.emailError = this.querySelector('.js-CustomerEmail')
    this.passwdError = this.querySelector('.js-CustomerPassword')
    this.loginFormSubmit = this.loginFormSubmit.bind(this)

    this.$submit.addEventListener('click', this.loginFormSubmit)
  }

  disconnectedCallback() {
    this.$submit.removeEventListener('click', this.loginFormSubmit)
  }

  loginFormSubmit(event) {
    event.preventDefault()

    let valid = true
    if (this.email.value === '') {
      this.emailError.classList.remove('hidden')
      this.emailError.querySelector('.customer__inner-form-error-wrap').focus()
      valid = false
    } else {
      this.emailError.classList.add('hidden')
    }

    if (this.passwd.value === '') {
      this.passwdError.classList.remove('hidden')
      if (valid) {
        this.passwdError
          .querySelector('.customer__inner-form-error-wrap')
          .focus()
        valid = false
      }
    } else {
      this.passwdError.classList.add('hidden')
    }

    if (!valid) {
      event.preventDefault()
    } else {
      sendLoginEvent('Login Form')
      this.$loginForm.submit()
    }
  }
}

customElements.define('hh-login-form', HHLoginForm)
